import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';

import {
  createInitialValues,
  createFormValidationFn,
} from 'client/helpers/formikHelpers';

import ButtonDeprecated, {
  BUTTON_THEME_BLUE_GREYCLIFF,
} from 'client/components/ButtonDeprecated';
import SrBox from 'client/components/SrBox';
import SrFormikErrorMessage from 'client/components/SrFormikErrorMessage';
import SrBarcodeScanner from 'client/components/SrBarcodeScanner';
import SrErrorMessage from 'client/components/SrErrorMessage/SrErrorMessage';
import SrText from 'client/components/SrText';
import SrFormikField, {
  SR_FIELD_THEME_ADOBE,
} from 'client/components/SrFormikField';

import './SrSunSetupDriverJobPage.less';

const YARD_SIGN_STATE_INITIAL = 'initial';
const YARD_SIGN_STATE_URL_SET = 'urlSet';
const YARD_SIGN_STATE_MANUAL_INPUT = 'manualInput';
const YARD_SIGN_STATE_BARCODE_SCANNER = 'barcodeScanner';

const yardSignUrlFormFields = [
  {
    id: 'yardSignUrl',
    type: 'short_text',
    properties: {
      placeholder: 'Write URL code here...',
    },
    validations: ['required'],
  },
];

const SrManualYardSignUrlForm = ({ onSubmit }) => {
  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={createInitialValues({ formFields: yardSignUrlFormFields })}
      validate={createFormValidationFn(yardSignUrlFormFields)}
      render={(formikBag) => (
        <Form>
          {yardSignUrlFormFields.map((formField) => (
            <SrFormikField
              formikBag={formikBag}
              formField={formField}
              theme={SR_FIELD_THEME_ADOBE}
              key={formField.id}
            />
          ))}
          <ButtonDeprecated
            margin='16px 0 0'
            type='submit'
            theme={BUTTON_THEME_BLUE_GREYCLIFF}
          >
            Submit
          </ButtonDeprecated>
        </Form>
      )}
    />
  );
};

SrManualYardSignUrlForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

SrManualYardSignUrlForm.displayName = 'SrManualYardSignUrlForm';

const SrSunSetupDriverJobYardSignSetup = ({
  formikBag,
  yardSignUrl,
  onYardSignBarcodeText,
}) => {
  const [viewState, setViewState] = useState(yardSignUrl
    ? YARD_SIGN_STATE_URL_SET
    : YARD_SIGN_STATE_INITIAL
  );
  const [yardSignMissingError, setYardSignMissingError] = useState(false);

  const _onYardSignUrl = (yardSignUrl) => {
    setYardSignMissingError(!yardSignUrl);
    setViewState(yardSignUrl
      ? YARD_SIGN_STATE_URL_SET
      : YARD_SIGN_STATE_INITIAL
    );
  };

  const _onManualYardSignUrl = ({ yardSignUrl }) => {
    onYardSignBarcodeText({ yardSignUrl })
      .then((yardSignUrl) => {
        return _onYardSignUrl(yardSignUrl);

      });
  };

  const _onYardSignBarcodeText = (barcode) => {
    onYardSignBarcodeText({ barcode })
      .then((yardSignUrl) => {
        return _onYardSignUrl(yardSignUrl);
      });
  };

  return (
    <div styleName='card' className='fieldsContainer' id='field-yardSignUrl'>
      <span styleName='cardTitle'>
        Register Yard Sign
      </span>

      <SrBox margin='16px 0 0'>
        {yardSignMissingError && viewState !== YARD_SIGN_STATE_MANUAL_INPUT && (
          <SrBox padding='0 0 16px'>
            <SrErrorMessage>
              Yard sign not found. Please try again.
            </SrErrorMessage>
          </SrBox>
        )}

        {viewState === YARD_SIGN_STATE_URL_SET && (
          <div styleName='sunlockBox'>
            <span styleName='title'>Yard Sign URL</span>
            <br />
            <span styleName='serialNumber'>
              {yardSignUrl}
            </span>
            <SrBox margin='16px 0 0'>
              <ButtonDeprecated
                theme={BUTTON_THEME_BLUE_GREYCLIFF}
                onClick={() => setViewState(YARD_SIGN_STATE_INITIAL)}
              >
                Scan Again
              </ButtonDeprecated>
            </SrBox>
          </div>
        )}
        {(
          viewState === YARD_SIGN_STATE_INITIAL
          || viewState === YARD_SIGN_STATE_BARCODE_SCANNER
        ) && (
          <>
            <ButtonDeprecated
              theme={BUTTON_THEME_BLUE_GREYCLIFF}
              onClick={() => setViewState(YARD_SIGN_STATE_BARCODE_SCANNER)}
            >
              Scan Barcode
            </ButtonDeprecated>

            <SrBox textAlign='center' padding='16px 0 0'>
              <SrText
                font='greycliff'
                weight='800'
                color='blue300'
                decoration='underline'
                size='16px'
                cursor='pointer'
                onClick={() => setViewState(YARD_SIGN_STATE_MANUAL_INPUT)}
              >
                Manually input URL
              </SrText>
            </SrBox>
          </>
        )}
        {viewState === YARD_SIGN_STATE_MANUAL_INPUT && (
          <>
            <SrManualYardSignUrlForm
              onSubmit={_onManualYardSignUrl}
            />
            <SrBox textAlign='center' padding='16px 0 0'>
              <SrText
                font='greycliff'
                weight='800'
                color='blue300'
                decoration='underline'
                size='16px'
                cursor='pointer'
                onClick={() => setViewState(YARD_SIGN_STATE_INITIAL)}
              >
                Scan Barcode
              </SrText>
            </SrBox>
          </>
        )}
      </SrBox>

      {viewState === YARD_SIGN_STATE_BARCODE_SCANNER && (
        <SrBarcodeScanner
          onText={_onYardSignBarcodeText}
          onClose={() => setViewState(YARD_SIGN_STATE_INITIAL)}
        />
      )}
      <SrFormikErrorMessage
        id='yardSignUrl'
        formikBag={formikBag}
      />
    </div>
  );
};

SrSunSetupDriverJobYardSignSetup.propTypes = {
  formikBag: PropTypes.object.isRequired,
  yardSignUrl: PropTypes.string,
  onYardSignBarcodeText: PropTypes.func.isRequired,
};

SrSunSetupDriverJobYardSignSetup.displayName = 'SrSunSetupDriverJobYardSignSetup';

export default SrSunSetupDriverJobYardSignSetup;
